export default __webpack_public_path__ + "static/media/wellness_note.b43f3afb.svg";